import React from "react";
import { Home, X } from "lucide-react";

export function ChatHeader({
  t,
  lang,
  setLang,
  tab,
  setTab,
  canUseLive,
  onClose,
  onNewChat,
  onClearHistory,
  onSignOut,
}) {
  return (
    <div className="flex-none p-3 md:p-5 bg-[#161B22]/30 backdrop-blur-xl border-b border-white/5 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 bg-[#00BCF0]/5 blur-2xl md:blur-3xl -z-0" />

      <div className="relative z-10 flex justify-between items-center mb-2 md:mb-3">
        <div className="flex items-center gap-2 md:gap-3">
          <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-[#00BCF0] to-[#008BB3] rounded-lg md:rounded-xl flex items-center justify-center shadow-[0_0_15px_rgba(0,188,240,0.3)]">
            <span className="font-black text-sm md:text-lg text-[#0B0F19] italic">
              C
            </span>
          </div>
          <div>
            <h3 className="font-black text-xs sm:text-xs md:text-sm lg:text-base uppercase tracking-wider italic text-white">
              {t.title} <span className="text-[#00BCF0]">{t.titleAccent}</span>
            </h3>
          </div>
        </div>

        <div className="flex items-center gap-1">
          {tab === "guide" && (
            <button
              type="button"
              title={t.newChat}
              onClick={onNewChat}
              className="p-1.5 md:p-2 text-slate-400 hover:text-[#EAB308] transition-colors">
              <Home size={18} />
            </button>
          )}
          {tab === "live" && canUseLive && (
            <>
              <button
                type="button"
                title={t.clearHistory}
                onClick={onClearHistory}
                className="px-1.5 md:px-2 py-1 text-[8px] sm:text-[8px] md:text-[9px] lg:text-[10px] font-black uppercase text-slate-500 hover:text-red-400">
                {t.clearHistory}
              </button>
              <button
                type="button"
                title={t.signOutLive}
                onClick={onSignOut}
                className="px-1.5 md:px-2 py-1 text-[8px] sm:text-[8px] md:text-[9px] lg:text-[10px] font-black uppercase text-slate-500 hover:text-[#00BCF0]">
                {t.signOutLive}
              </button>
            </>
          )}
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 md:p-2 text-slate-400 hover:rotate-90 transition-all duration-300">
            <X size={20} />
          </button>
        </div>
      </div>

      <div className="relative z-10 flex flex-wrap gap-1.5 md:gap-2 mb-2 md:mb-3">
        <div className="flex bg-black/40 p-1 rounded-lg border border-white/5">
          {["en", "mm"].map((l) => (
            <button
              key={l}
              type="button"
              onClick={() => setLang(l)}
              className={`px-2 md:px-3 py-1 text-[9px] md:text-[10px] font-black rounded-md transition-all uppercase ${
                lang === l ?
                  "bg-[#00BCF0] text-[#0B0F19]"
                : "text-slate-500 hover:text-white"
              }`}>
              {l}
            </button>
          ))}
        </div>
        <div className="flex bg-black/40 p-1 rounded-lg border border-white/5 ml-auto">
          <button
            type="button"
            onClick={() => setTab("guide")}
            className={`px-2 md:px-3 py-1 text-[9px] md:text-[10px] font-black rounded-md uppercase ${
              tab === "guide" ?
                "bg-[#00BCF0] text-[#0B0F19]"
              : "text-slate-500 hover:text-white"
            }`}>
            {t.guideTab}
          </button>
          <button
            type="button"
            onClick={() => setTab("live")}
            className={`px-2 md:px-3 py-1 text-[9px] md:text-[10px] font-black rounded-md uppercase ${
              tab === "live" ?
                "bg-[#00BCF0] text-[#0B0F19]"
              : "text-slate-500 hover:text-white"
            }`}>
            <div className="relative flex items-center">
              <span>{t.liveTab}</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
